module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.0013 13.3327V7.99935M8.0013 7.99935V2.66602M8.0013 7.99935H13.3346M8.0013 7.99935H2.66797",
      "stroke": _vm.color || _vm.fillColor,
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26b60504"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Plus.vue
// module id = 1482
// module chunks = 159